const moduleMap = {
	"./Pages": () => {
		return Promise.all([__webpack_require__.e(27127), __webpack_require__.e(28270), __webpack_require__.e(40798), __webpack_require__.e(67436), __webpack_require__.e(57389), __webpack_require__.e(79828), __webpack_require__.e(4754), __webpack_require__.e(35260), __webpack_require__.e(26825), __webpack_require__.e(63796), __webpack_require__.e(31152), __webpack_require__.e(14462), __webpack_require__.e(78804), __webpack_require__.e(24004), __webpack_require__.e(96180), __webpack_require__.e(54323), __webpack_require__.e(35479), __webpack_require__.e(64309), __webpack_require__.e(31462), __webpack_require__.e(88855), __webpack_require__.e(56676), __webpack_require__.e(68704), __webpack_require__.e(188), __webpack_require__.e(35457), __webpack_require__.e(17492), __webpack_require__.e(5989), __webpack_require__.e(70393), __webpack_require__.e(30735), __webpack_require__.e(42977), __webpack_require__.e(91202), __webpack_require__.e(10311), __webpack_require__.e(69580), __webpack_require__.e(35508), __webpack_require__.e(12135), __webpack_require__.e(6497), __webpack_require__.e(63842), __webpack_require__.e(19385), __webpack_require__.e(98122), __webpack_require__.e(40711), __webpack_require__.e(77934), __webpack_require__.e(71342), __webpack_require__.e(269), __webpack_require__.e(13593), __webpack_require__.e(68044)]).then(() => (() => ((__webpack_require__(844830)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});